import Row from "@/components/Ui/Row";
import { TriangleAlert } from "lucide-react";
import { useFeatureFlagEnabled } from "posthog-js/react";

const ImportPreviewBanner = () => {
  const isImportPreview = useFeatureFlagEnabled("import-preview-mode");

  if (isImportPreview !== true) return null;

  return (
    <Row className="text-uncertain border-uncertain/20 bg-uncertain/10 w-full gap-2 border-b px-4 py-2 text-sm shadow-[inset_0_2px_4px_0_rgba(0,0,0,0.15)]">
      <TriangleAlert className="size-4 shrink-0" />
      You&apos;re previewing imported data — Feel free to explore, but any edits
      will be replaced when the final import runs.
    </Row>
  );
};

export default ImportPreviewBanner;
